import type { QueryParamValuesSetter } from "@octopusdeploy/portal-routes";
import React from "react";
import type { StepTemplatePageQueryParams } from "./StepTemplatePage";
import { StepTemplatePage } from "./StepTemplatePage";
export interface StepTemplateDetailsPageProps {
    spaceId: string;
    templateId: string;
    onActionTemplateUpdated: () => void;
    queryParams: StepTemplatePageQueryParams;
    setQueryParams: QueryParamValuesSetter<StepTemplatePageQueryParams>;
}
export function StepTemplateDetailsPage({ spaceId, templateId, onActionTemplateUpdated, queryParams, setQueryParams }: StepTemplateDetailsPageProps) {
    return <StepTemplatePage spaceId={spaceId} templateId={templateId} onActionTemplateUpdated={onActionTemplateUpdated} queryParams={queryParams} setQueryParams={setQueryParams}/>;
}
